import request from '@capturi/request'
import { Box, Flex, IconButton, Input, Text } from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import { FC, useState } from 'react'
import { MdCopyAll } from 'react-icons/md'

type Event = {
  data: string
  organizationUid: string
  sessionUid: string
  ts: number
}

export const CopilotEvents: FC = () => {
  const [searchTerm, setSearchTTerm] = useState('')

  const { data, error, isLoading } = useQuery<Event[], Error>({
    queryKey: ['hedwig', searchTerm],
    enabled: !!searchTerm,
    refetchInterval: searchTerm ? 4 * 1000 : false,
    queryFn: () =>
      request.get('hedwig/letter', { searchParams: { q: searchTerm } }),
  })

  const handleCopy = () => {
    navigator.clipboard.writeText(
      JSON.stringify(
        data?.map((d) => ({ ...d, data: JSON.parse(d.data) })),
        undefined,
        3,
      ),
    )
  }

  const d = data
    ?.slice(0, 1000)
    ?.map((d) => ({ ...d, data: JSON.parse(d.data) }))
  // const d = JSON.stringify(data, undefined, '   ')
  return (
    <Box>
      <Flex>
        <Input
          onChange={(e) => setSearchTTerm(e.currentTarget.value)}
          value={searchTerm}
        />
        <IconButton
          icon={<MdCopyAll />}
          aria-label="copy"
          onClick={handleCopy}
        />
      </Flex>
      <Text whiteSpace="break-spaces" fontFamily="monospace">
        Events: {data?.length || 0}
      </Text>

      {!!error && <Text color="danger">{error.message}</Text>}
      {!!isLoading && <Text color="textMuted">Loading</Text>}
      {!!data && (
        <Text whiteSpace="break-spaces" fontFamily="monospace">
          {JSON.stringify(d, undefined, '   ')}
        </Text>
      )}
    </Box>
  )
}
